import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  ModalContent,
  Modal,
} from "semantic-ui-react";
import MemberInformation from "../MyInformation/MemberInformation";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import PageLoader from "../../Common/PageLoader";
import {Types} from "../../../utils/Types"

function Table({ name, color, add, data, onRefresh }) {
  const [isLoading, setIsLoading] = useState(false);
  const [contactId, setContactId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [error, setError] = useState("");
  // const [employmentPass, setEmploymentPass] = useState(false);
  // const [submitPass, setSubmitPass] = useState(false);
  const [createContact, setCreateContact] = useState(false);
  const [message, setMessage] = useState("");

  // Function to refetch user data
  const refetchUserData = async () => {
    if (contactId) {
      try {
        setIsLoading(true);
        const res = await getApiClient().getUserInfo(contactId);
        
        if (res) {
          setUserData(res.data);
        }
      } catch (error) {
        makeStandardApiErrorHandler((error) => console.log(error))(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

 useEffect(() => {
    if (contactId) {

      setCreateContact(false);
      setIsLoading(true);
      setUserData(null); 
      
      getApiClient()
        .getUserInfo(contactId)
        .then((res) => {
          if (res) {
            setUserData(res.data);
          }
        })
        .catch(makeStandardApiErrorHandler((error) => console.log(error)))
        .finally(() => {
          setOpenModal(true);
          setIsLoading(false);
        });
    }
  }, [contactId]);

  // const handleAddModalClose = () => {
  //   setOpenAddModal(false);
  //   onRefresh();
  // };

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Container color={color}>
        <TopContainer>
          <Header>{name}</Header>
<HeaderCell
  negative
  onClick={() => {
    if (!(name === Types.SPOUSE && data.length > 0)) {
      setCreateContact(true);
      setContactId(null);
      setUserData(null);
      setOpenModal(true);
    }
  }}
  style={{
    cursor:
      name === Types.SPOUSE && data.length > 0
        ? "not-allowed"
        : "pointer",
    opacity: name === Types.SPOUSE && data.length > 0 ? 0.5 : 1,
  }}
>
  + Add {add}
</HeaderCell>
        </TopContainer>
        <SubContainer>
          <Row
            style={{
              background: "white",
              borderRadius: "5px 5px 0px 0px",
            }}
          >
            <HeaderCell>Name</HeaderCell>
            <HeaderCell style={{}}></HeaderCell>
          </Row>
          <Body color={color}>
            {data.length > 0 ? (
              data.map((member) => {
                return (
                  <BodyRow key={member.contactid}>
                    <Cell>{member.fullname}</Cell>
                    <Cell
                      borderleft={true}
                      style={{}}
                      onClick={() => {
                        if (contactId === member.contactid) {
                          setOpenModal(true);
                        } else {
                          setContactId(member.contactid);
                        }
                      }}
                    >
                      Edit
                    </Cell>
                  </BodyRow>
                );
              })
            ) : (
              <BodyRow>
                <Cell
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Nothing Found
                </Cell>
              </BodyRow>
            )}
          </Body>
        </SubContainer>
<Modal
  style={{ marginBottom: "20px" }}
  size={"large"}
  open={openModal}
  onClose={() => {
    setOpenModal(false);
    setCreateContact(false);
    setContactId(null);
    setUserData(null);
    setError("");
    setMessage("");
  }}
>


          <ModalContent>
            <MemberInformation error={error} message={message} data={userData} contactId={contactId} refetchData={refetchUserData} type={name} createContact={createContact} setOpenModal = {setOpenModal}/>
              {/* <GeneralInformationSection
                setMessage={setMessage}
                submitPass={submitPass}
                setSubmitPass={setSubmitPass}
                setEmploymentPass={setEmploymentPass}
                setError={setError}
                employmentPass={employmentPass}
                setData={setUserData}
                contactId={contactId}
                data={userData}
                refetchData={refetchUserData}
              />
              {name !== "Children" && (
                <>
                  <EmploymentInformation
                    setMessage={setMessage}
                    employmentPass={employmentPass}
                    submitPass={submitPass}
                    setEmploymentPass={setEmploymentPass}
                    contactId={contactId}
                    data={userData}
                    refetchData={refetchUserData}
                  />
                  <CitizenshipSection
                    contactId={contactId}
                    data={userData}
                    refetchData={refetchUserData}
                  />
                  <ContactInformation
                    contactId={contactId}
                    data={userData}
                    refetchData={refetchUserData}
                  />
                  <HomeAddress
                    contactId={contactId}
                    data={userData}
                    showSameAddressCheckbox={
                      add === "Spouse" || add === "Child"
                    }
                    recordType={add}
                    refetchData={refetchUserData}
                  />
                  <DriversLicense
                    contactId={contactId}
                    data={userData}
                    refetchData={refetchUserData}
                  />
                  <OtherInformation
                    contactId={contactId}
                    data={userData}
                    refetchData={refetchUserData}
                  />
                </>
              )} */}
          </ModalContent>
      
        </Modal>
        {/* { <CreateRecord
          add={add}
          openAddModal={openAddModal}
          setOpenAddModal={handleAddModalClose}
          onRefresh={onRefresh}
        /> } */}
      </Container>
    </>
  );
}

const Container = styled.div`
  display: grid;
  width: 100%;
  gap: 20px;
  min-height: 100px;
  border-radius: 20px;
  background: ${(props) =>
    props.color ? props.color : "rgba(91, 196, 241, 0.15)"};
  padding: 20px;
`;
const SubContainer = styled.div`
  display: grid;
  width: 100%;
  min-height: 100px;
`;
const Body = styled.div`
  display: grid;
  width: 100%;
  gap: 5px;
  background-color: white;
  background: ${(props) =>
    props.color
      ? "linear-gradient(180deg, rgba(251, 198, 125, 0.50) 0%, rgba(251, 198, 125, 0.00) 100%)"
      : "linear-gradient(180deg,rgba(100, 194, 200, 0.5) 0%,rgba(100, 193, 198, 0) 100%)"};
  padding: 5px;
`;
const Header = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.402px;
`;
const Row = styled.div`
  display: grid;
  padding: 10px;
  grid-template-columns: 3fr 0.5fr;
`;
const BodyRow = styled.div`
  display: grid;
  padding: 10px;
  grid-template-columns: 3fr 0.5fr;
  background-color: white;
  border-radius: 5px;
`;

const HeaderCell = styled.div`
  color: #304961;
  border-left: ${(props) => (props.borderleft ? "1px solid black" : "")};
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  padding: 0px 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24.102px; /* 150.637% */
  letter-spacing: -0.32px;
`;
const Cell = styled.div`
  color: #304961;
  border-left: ${(props) => (props.borderleft ? "1px solid black" : "")};
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  padding: 0px 20px;
  font-style: normal;
  line-height: 24.102px; /* 150.637% */
  letter-spacing: -0.32px;
  cursor: ${(props) => (props.borderleft ? "pointer" : "default")};
`;

const TopContainer = styled.div`
  display: flex;
  algin-items: center;
  justify-content: space-between;
`;

// const PageInfoTitle = styled.div`
//   color: #304961;
//   font-family: "Museo Sans Cyrl";
//   font-size: 30px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 23.402px;
// `;

// const PageInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content: start;
//   gap: 50px;
//   flex: 1;
//   min-height: 50vh;
//   background-color: #ecf3fb;
//   border-radius: 20px;
//   padding: 30px 35px;
//   @media screen and (max-width: 450px) {
//     padding: 15px;
//   }
// `;

// const CancelButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   min-width: 100px;
//   height: 40px;
//   padding: 0px 20px;
//   border-radius: 20px;
//   border: 2px solid #e0e0e0;
//   background-color: #f8f9fa;
//   color: #6c757d;
//   cursor: pointer;
//   font-family: "Museo Sans Cyrl";
//   font-size: 12px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: normal;
//   text-transform: uppercase;
//   transition: all 0.2s ease;

//   &:hover {
//     background-color: #e9ecef;
//     border-color: #d0d0d0;
//     color: #495057;
//   }

//   &:active {
//     background-color: #dee2e6;
//     transform: translateY(1px);
//   }
// `;

// const ButtonContainer = styled(ModalActions)`
//   display: flex;
//   align-items: center;
//   justify-content: right;
// `;

// const ErrorMessage = styled.div`
//   color: #b20000;
//   font-family: "Museo Sans Cyrl";
//   font-size: 16px;
//   line-height: 1.6;
//   background-color: #fff5f5;
//   border: 1px solid #f3d6d6;
//   border-left: 4px solid #b20000;
//   padding: 16px 18px;
//   border-radius: 8px;
//   box-shadow: 0 2px 4px rgba(178, 0, 0, 0.05);
// `;

// const Message = styled.div`
//   color: #304961;
//   font-family: "Museo Sans Cyrl";
//   font-size: 16px;
//   line-height: 1.6;
//   background-color: rgb(252, 254, 255);
//   border: 1px solid rgb(214, 231, 243);
//   border-left: 4px solid #304961;
//   padding: 16px 18px;
//   border-radius: 8px;
//   box-shadow: 0 2px 4px rgba(48, 73, 97, 0.05);
// `;

export default Table;
